
































import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { LibraryMixin, HistoryViewMixin } from '@/mixins'
import { IRule, executeRuleFilters } from '@/helpers/filter-rules'

@Component({
  components: {
    RuleFilter: require('./RuleFilter').default,
    Preview: require('./Preview').default,
    TemplateSaveModal: require('@/components/TemplateSaveModal').default
  }
})
export default class SearchFilter extends Mixins(LibraryMixin, HistoryViewMixin) {
  @Prop({
    required: true
  })
  target: string

  @Prop({
    default: 'Continue'
  })
  confirmLabel: string

  results: Track[] = []
  rules: IRule[] = this.$store.state.trackselectwizard.rules[this.target]
  valid: boolean = true

  loading: boolean = false

  debounceTimeout: any = null

  get tracks(): Track[] {
    if (!this.library) return []

    return this.library.tracks
  }

  get disabled(): boolean {
    return this.loading || this.results.length === 0
  }

  get autoPreview(): boolean {
    return this.tracks.length < 200000
  }

  get debounceTimeoutMs(): number {
    return this.tracks.length > 100000 ? 1000 : this.tracks.length > 10000 ? 500 : 200
  }

  onTemplateChange(rules: IRule[]) {
    this.$store.commit('trackselectwizard/setRules', {
      target: this.target,
      rules
    })
  }

  async preview() {
    if (!this.valid || !this.library) return

    this.loading = true

    if (this.rules.length === 0) {
      this.results = this.tracks
    } else {
      this.results = executeRuleFilters(this.tracks, this.rules)
    }

    this.loading = false
  }

  async confirm() {
    if (this.loading) return

    this.$emit('confirm', this.results)
  }

  created() {
    this.$watch(`$store.state.trackselectwizard.rules.${this.target}`, (rules: IRule[]) => {
      this.rules = rules
    })
  }

  @Watch('rules')
  async watchRules(rules: IRule[]) {
    if (rules.length === 0 || this.autoPreview) {
      this.loading = true

      clearTimeout(this.debounceTimeout)

      this.debounceTimeout = setTimeout(async () => {
        await this.preview()
      }, this.debounceTimeoutMs)
    }
  }

  @Watch('library')
  async watchLibrary() {
    await this.preview()
  }
}
